export default {
  pagination: {},
  invoices: []
};
